import React from 'react';
import {
  isDatabaseHolesLayer,
  resolvedIntervalVisible,
  useHoleDisplayStore,
} from '../../store/holeDisplayStore';
import LegendToggleButton from '../ui/LegendToggleButton';

function AssayIcon() {
  return (
    <svg viewBox="0 0 16 16" className="h-3.5 w-3.5" fill="none" aria-hidden>
      <path
        d="M5.5 2.5h5M6.5 2.5v3.2L3.8 13.2A1.2 1.2 0 005 14.8h6a1.2 1.2 0 001.2-1.6L9.5 5.7V2.5"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.2 9.2h3.6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}

function LithIcon() {
  return (
    <svg viewBox="0 0 16 16" className="h-3.5 w-3.5" fill="none" aria-hidden>
      <path d="M2.5 5.2L8 2.8l5.5 2.4-5.5 2.2L2.5 5.2z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M2.5 8.4L8 10.6l5.5-2.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5 11.4L8 13.6l5.5-2.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const iconBtn =
  'm-0 h-5 w-5 shrink-0 inline-flex items-center justify-center rounded-sm border transition-colors';

export default function HoleLayerActions({ model }) {
  const intervalVisibleByLayer = useHoleDisplayStore((s) => s.intervalVisibleByLayer);
  const legendOpen = useHoleDisplayStore((s) => s.legendOpenByLayer[model?.name]);
  const toggleIntervalVisible = useHoleDisplayStore((s) => s.toggleIntervalVisible);
  const toggleLegend = useHoleDisplayStore((s) => s.toggleLegend);

  if (!isDatabaseHolesLayer(model)) return null;

  const vis = resolvedIntervalVisible(model.name, intervalVisibleByLayer);
  const isPlan = !!model.isplan;

  return (
    <span className="inline-flex items-center gap-0.5 shrink-0">
      {!isPlan && (
        <>
      <button
        type="button"
        title={vis.assay ? 'Hide assays' : 'Show assays'}
        aria-label={vis.assay ? 'Hide assays' : 'Show assays'}
        aria-pressed={vis.assay}
        className={`${iconBtn} ${
          vis.assay
            ? 'border-yellow-600/40 bg-yellow-500/15 text-yellow-300 hover:bg-yellow-500/25'
            : 'border-zinc-700 text-zinc-500 hover:text-zinc-300 hover:border-zinc-500'
        }`}
        onClick={(e) => {
          e.stopPropagation();
          toggleIntervalVisible(model.name, 'assay');
        }}
      >
        <AssayIcon />
      </button>
      <button
        type="button"
        title={vis.lith ? 'Hide geology' : 'Show geology'}
        aria-label={vis.lith ? 'Hide geology' : 'Show geology'}
        aria-pressed={vis.lith}
        className={`${iconBtn} ${
          vis.lith
            ? 'border-emerald-500/50 bg-emerald-500/15 text-emerald-300 hover:bg-emerald-500/25'
            : 'border-zinc-700 text-zinc-500 hover:text-zinc-300 hover:border-zinc-500'
        }`}
        onClick={(e) => {
          e.stopPropagation();
          toggleIntervalVisible(model.name, 'lith');
        }}
      >
        <LithIcon />
      </button>
        </>
      )}
      <LegendToggleButton
        pressed={!!legendOpen}
        title="Show colour legend"
        onClick={() => toggleLegend(model.name)}
      />
    </span>
  );
}
